import PlayerCategorySelect from "./PlayerCategorySelect";
import { PLAYER_CATEGORY_OPTIONS } from "./PlayerCategorySelect";
import PlayerSexSelect from "./PlayerSexSelect";
import SearchInput from "./SearchInput";
import "./PlayerFiltersBar.css";

type PlayerFiltersBarProps = {
  ariaLabel: string;
  categoryAllValue?: string;
  categoryIncludeAll?: boolean;
  categoryLabel: string;
  categoryOptions?: typeof PLAYER_CATEGORY_OPTIONS;
  categoryValue: string;
  className?: string;
  onCategoryChange: (value: string) => void;
  onSearchChange?: (value: string) => void;
  onSearchClear?: () => void;
  onSexChange: (value: string) => void;
  searchAriaLabel?: string;
  searchPlaceholder?: string;
  searchValue?: string;
  sexAllValue?: string;
  sexIncludeAll?: boolean;
  sexLabel: string;
  sexValue: string;
};

export default function PlayerFiltersBar({
  ariaLabel,
  categoryAllValue = "",
  categoryIncludeAll = true,
  categoryLabel,
  categoryOptions,
  categoryValue,
  className = "",
  onCategoryChange,
  onSearchChange,
  onSearchClear,
  onSexChange,
  searchAriaLabel,
  searchPlaceholder,
  searchValue = "",
  sexAllValue = "",
  sexIncludeAll = true,
  sexLabel,
  sexValue,
}: PlayerFiltersBarProps) {
  const hasSearch = Boolean(onSearchChange);

  return (
    <div
      className={`player-filters-bar ${
        hasSearch ? "has-search" : "has-player-fields-only"
      }${className ? ` ${className}` : ""}`}
      aria-label={ariaLabel}
    >
      {hasSearch && (
        <SearchInput
          inputType="search"
          value={searchValue}
          placeholder={searchPlaceholder}
          aria-label={searchAriaLabel || searchPlaceholder}
          onChange={(event) => onSearchChange(event.target.value)}
          onClear={onSearchClear || (() => onSearchChange(""))}
        />
      )}
      <label className="player-filters-bar__field">
        <span className="player-filters-bar__label">
          <span className="material-symbols-outlined" aria-hidden="true">
            category
          </span>
          {categoryLabel}
        </span>
        <PlayerCategorySelect
          includeAll={categoryIncludeAll}
          allValue={categoryAllValue}
          options={categoryOptions}
          value={categoryValue}
          onChange={(event) => onCategoryChange(event.target.value)}
        />
      </label>
      <label className="player-filters-bar__field">
        <span className="player-filters-bar__label">
          <span className="material-symbols-outlined" aria-hidden="true">
            wc
          </span>
          {sexLabel}
        </span>
        <PlayerSexSelect
          includeAll={sexIncludeAll}
          allValue={sexAllValue}
          value={sexValue}
          onChange={(event) => onSexChange(event.target.value)}
        />
      </label>
    </div>
  );
}
